<div class="scroll-container" style="overflow-y: auto" [style.height]="getDynamicHeight()"
    *ngIf="this.selectedNode.data.model && this.selectedNode.data.model.length > 0">
    <table class="table table-striped table-hover table-sm table-max-width">
        <thead style="position: sticky;top: 0;">
            <tr>
                <th *ngFor="let column of selectedNode.data.itemFinderArrayColumns; let i = index" appResizableColumn
                    [columnIndex]="i" [storageKey]="'itemsTable:' + column.getSourceName()"
                    style="cursor: default; overflow: hidden; text-overflow: ellipsis;">
                    <a (click)="sortBy(column, selectedNode.data.model)" style="cursor: pointer;">
                        {{ column.getHeader() }} {{ sortIcon(column.getSourceName()) }}
                    </a>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of this.selectedNode.data.model" (click)="selectRow(item)" [ngClass]="{'selected-row': item === selectedItem}">
                <td *ngFor="let column of this.selectedNode.data.itemFinderArrayColumns"
                    (click)="(column.getSourceName()!=='num')?onItemFinderDoubleClick(getChildenNode(item)):null"
                    style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;"><input
                        *ngIf="(column.getSourceName()=='num') && !this.excludeCheckBox()" class="mr-5" type="checkbox"
                        (change)="select($event, this.selectedNode, item)" [checked]="item.checked" /><span
                        [className]="this.isWebTraderQueryResultNode()?'underline':''">
                        {{ this.displayValue(item[column.getSourceName()], column.getDataType(), column.getLookup())
                        }}</span></td>
            </tr>
        </tbody>
    </table>
</div>